import type { CashoutMethodId } from '../../types';

interface PaymentMethodOptionProps {
  id: CashoutMethodId;
  icon: string;
  title: string;
  subtitle: string;
  selected: boolean;
  onSelect: (id: CashoutMethodId) => void;
}

export function PaymentMethodOption({ id, icon, title, subtitle, selected, onSelect }: PaymentMethodOptionProps) {
  return (
    <button
      className={`method-option ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(id)}
      type="button"
    >
      <div className="method-icon">{icon}</div>
      <div>
        <div className="method-title title-medium title-subtle">{title}</div>
        <div className="method-sub">{subtitle}</div>
      </div>
      <div className="method-radio" />
    </button>
  );
}
